import { useParams, Link } from 'react-router-dom'
import { ArrowLeft } from 'lucide-react'
import { QueturePlayer } from '@quebon/shared-learning'
import type { QuetureApiInterface } from '@quebon/shared-learning'
// TODO: contentId 없이 QID만으로 영상 조회 불가 (API가 /content/{contentId}/quetures/{quetureId}로 변경됨)
// 이 페이지는 contentId 기반 API로 전환 필요
const quetureApiAdapter: QuetureApiInterface = {
  getQuetureInfo: async () => {
    throw new Error('QueturePage: contentId 없이 QID만으로 영상 조회 불가')
  }
}

/**
 * Queture 영상 직접 재생 페이지
 * /learn/queture/{qid} 경로로 접근
 */
export function QueturePage() {
  const { qid } = useParams<{ qid: string }>()

  if (!qid) {
    return (
      <div className="flex flex-col items-center justify-center min-h-[400px]">
        <p className="text-gray-900 font-medium mb-2">영상 ID가 필요합니다</p>
        <Link to="/learn" className="text-primary-600 hover:underline">
          목록으로 돌아가기
        </Link>
      </div>
    )
  }

  return (
    <div className="space-y-6 max-w-4xl mx-auto">
      {/* Back Button */}
      <Link
        to="/learn"
        className="inline-flex items-center gap-2 text-gray-600 hover:text-gray-900 transition-colors"
      >
        <ArrowLeft className="w-4 h-4" />
        <span>학습 목록으로</span>
      </Link>

      {/* Video Player */}
      <div className="card overflow-hidden">
        <QueturePlayer qid={qid} quetureApi={quetureApiAdapter} />
        
        <div className="p-6">
          <div className="flex items-center gap-2 mb-2">
            <span className="px-2 py-0.5 bg-primary-100 text-primary-700 text-xs font-medium rounded-full">
              Queture
            </span>
          </div>
        </div>
      </div>
    </div>
  )
}
